import { create } from 'zustand';

/**
 * Route-scoped header CTA override. Creator channel pages register their
 * handler on mount so the guest TopHeader swaps "Get Started" for the
 * value-led "Unlock everything" CTA — only there, and with the creator's
 * promo-aware plan href. A stack (not a boolean) so overlapping
 * mount/unmount during creator→creator route transitions can't clear the
 * flag early.
 */
interface HeaderCtaState {
  unlockCtaHandlers: string[];
  registerUnlockCta: (handler: string) => void;
  unregisterUnlockCta: (handler: string) => void;
}

export const useHeaderCtaStore = create<HeaderCtaState>((set) => ({
  unlockCtaHandlers: [],
  registerUnlockCta: (handler) =>
    set((s) => ({ unlockCtaHandlers: [...s.unlockCtaHandlers, handler] })),
  unregisterUnlockCta: (handler) =>
    set((s) => {
      const idx = s.unlockCtaHandlers.indexOf(handler);
      if (idx === -1) return s;
      return { unlockCtaHandlers: s.unlockCtaHandlers.filter((_, i) => i !== idx) };
    }),
}));
